import { CATEGORIES } from "@/lib/categories";

const WORD = "Collezionatico";

/* Same ten colours as the medieval banner in the masthead (one per category). */
const BRAND_PALETTE = CATEGORIES.map((c) => c.hex);

const SIZES = {
  sm: { word: "text-xl", tile: "w-8 h-8", gap: "gap-2.5", tag: "text-[8px]" },
  md: { word: "text-[26px] sm:text-3xl", tile: "w-11 h-11", gap: "gap-3", tag: "text-[8px]" },
  lg: { word: "text-4xl sm:text-5xl", tile: "w-16 h-16", gap: "gap-4", tag: "text-[9px]" },
  xl: { word: "text-[30px] sm:text-[42px] lg:text-[52px]", tile: "w-14 h-14 sm:w-[76px] sm:h-[76px]", gap: "gap-3 sm:gap-4", tag: "text-[10px]" },
};

/** Collectible objects mark + editorial wordmark in the ten category colours. */
export function Brand({ size = "md", tagline = true, className = "" }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`brand group/brand inline-flex items-center ${s.gap} ${className}`} data-testid="brand-wordmark">
      <img src="/brand/logo-mark-160.png" alt="" aria-hidden="true" width="160" height="160"
        className={`brand-emblem ${s.tile} shrink-0`} loading="eager" decoding="async" />
      <span className="flex flex-col">
        <span className={`font-editorial font-extrabold tracking-tight leading-none flex ${s.word}`}>
          {WORD.split("").map((ch, i) => (
            <span key={i} className="brand-letter"
              style={{
                color: BRAND_PALETTE[i % BRAND_PALETTE.length],
                "--rot": `${(i % 2 ? 1 : -1) * (1 + (i % 3) * 1.4)}deg`,
                transitionDelay: `${i * 22}ms`,
              }}>
              {ch}
            </span>
          ))}
        </span>
        {tagline && (
          <span className={`hidden sm:inline-flex w-fit items-center gap-1.5 mt-1.5 px-2 py-0.5 rounded-full bg-[#6D062D] font-meta uppercase tracking-[0.2em] text-amber-200 ${s.tag}`}>
            Notizie · Guide · Valori
          </span>
        )}
      </span>
    </span>
  );
}
